import EventHomeScheduleAction from '@/screens/EventHomeScheduleAction';

export default function PrivateEventActionIndexRoute() {
  return <EventHomeScheduleAction />;
}
